import type { useFormErrors } from './useFormErrors';

interface Props {
  form: ReturnType<typeof useFormErrors>;
  name: string;
}

/**
 * Подпись об ошибке под полем.
 *
 * Именно под полем, а не в модальном окне: окно приходится закрыть, и после
 * этого человек заново ищет глазами, что не так. Текст с `id`, на который
 * ссылается `aria-describedby` поля, — иначе программа чтения с экрана
 * объявит поле неверным, но не скажет почему.
 */
export default function FieldError({ form, name }: Props) {
  const text = form.errors[name];
  if (!text) return null;

  return (
    <span className="field__err" id={`err-${name}`} role="alert">
      {text}
    </span>
  );
}
